import { render, staticRenderFns } from "./PageContentMobile.vue?vue&type=template&id=e37162f6&scoped=true"
import script from "./PageContentMobile.vue?vue&type=script&lang=js"
export * from "./PageContentMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37162f6",
  null
  
)

export default component.exports